App.namespace.wrap('components.room_cards_carousel', (options = {}) => {
  const ARROW_SCROLL_PADDING = options.padding || 21;

  const updateArrows = ($carousel) => {
    const $carouselInner = $carousel.find('.c-box-carousel-inner');

    const carouselWidth = $carousel.outerWidth();
    const carouselInnerWith = $carouselInner.width();
    const carouselScrollLeft = $carousel.scrollLeft();

    // we do some math on pixels here, but when browser zooming is different than 100%
    // we are getting fractional parts of pixels and our math doesn't add up
    // so we assume margin of error, if it's below this value we assume things are equal
    const ZOOMING_UNCERTAINTY = 0.99;

    $carousel.addClass('c-box-carousel--loaded');

    $carousel.toggleClass('c-box-carousel--no-arrows', carouselInnerWith <= carouselWidth);
    $carousel.toggleClass('c-box-carousel--beginning', carouselScrollLeft <= ZOOMING_UNCERTAINTY);
    $carousel.toggleClass(
      'c-box-carousel--end',
      carouselWidth + carouselScrollLeft + ZOOMING_UNCERTAINTY >= carouselInnerWith,
    );
  };

  const updateAllCarouselArrows = () => {
    $('.c-box-carousel').each((i, element) => {
      updateArrows($(element));
    });
  };

  let animatingTarget;
  const carouselScroll = (direction, event) => {
    const $el = $(event.target);
    const $carousel = $el.parents('.c-box-carousel-wrap').children('.c-box-carousel');
    const carouselName = $carousel.data('name');
    const carouselPadding = +$carousel.data('padding') || ARROW_SCROLL_PADDING;
    const left = $carousel.scrollLeft();

    const step = $carousel.find('.c-box-carousel__item, .c-room-card__img_wrap').eq(0).outerWidth() + carouselPadding;

    if (!animatingTarget) {
      animatingTarget = left + (step * direction);
    } else {
      animatingTarget += (step * direction);
    }

    $carousel.stop().animate({
      scrollLeft: animatingTarget,
      queue: false,
    }, {
      duration: 300,
      complete() {
        updateArrows($carousel);
        animatingTarget = null;
      },
      start() {
        setTimeout(() => {
          updateArrows($carousel);
        });
      },
    });
  };

  if (options?.updateArrowsOnly) {
    updateAllCarouselArrows();
    return;
  }

  $('.c-box-carousel-arrow--left').on('click', carouselScroll.bind(null, -1));
  $('.c-box-carousel-arrow--right').on('click', carouselScroll.bind(null, 1));

  window.addEventListener('resize', updateAllCarouselArrows);

  updateAllCarouselArrows();
});
